import { render, staticRenderFns } from "./GroupBottomBar.vue?vue&type=template&id=f8b5ea80&"
import script from "./GroupBottomBar.vue?vue&type=script&lang=js&"
export * from "./GroupBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports